module.exports = __webpack_public_path__ + "img/business_wx_new.9c0a29df.jpg";